<template>
  <layout>
    <div class="section">
      <div class="content">
        <div class="nav-warrp">
          <div :class="['nav-item',{active: type == 0}]" @click="evt_select(0)">
            <div class="info">
              <div class="f-text">域名注册</div>
              <div class="d-text">首年注册</div>
            </div>
          </div>
          <div :class="['nav-item',{active: type == 1}]" @click="evt_select(1)">
            <div class="info">
              <div class="f-text">续费价格</div>
              <div class="d-text">单年续费价格</div>
            </div>
          </div>
          <div :class="['nav-item',{active: type == 2}]" @click="evt_select(2)">
            <div class="info">
              <div class="f-text">转入价格</div>
              <div class="d-text">含一年续费价格</div>
            </div>
          </div>
        </div>
        <div style="margin-top: 53px">
          <Table
            class="custom-table"
            stripe
            border
            :columns="columns"
            :data="list"
          >
          </Table>
        </div>
      </div>
    </div>
  </layout>
</template>
<script>
import layout from "./components/layout.vue";
import { getPriceList } from "api/domain.js";
export default {
  name: "price",
  components: {
    layout,
  },
  data() {
    return {
      columns: [
        {
          width: 600,
          title: "域名后缀",
          key: "name",
          align: "center",
          render: (h, { row }) => {
            return h(
              "div",
              {
                style: {
                  paddingLeft: "40px",
                  textAlign: "left",
                  display: "flex",
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      marginRight: "40px",
                      textDecoration: "underline",
                      flex: "0 0 100px",
                    },
                  },
                  row.suffix
                ),
                h(
                  "span",
                  {
                    style: {
                      flex: "1",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      "-webkit-line-clamp": 1,
                      "-webkit-box-orient": "vertical",
                    },
                  },
                  row.desc
                ),
              ]
            );
          },
        },
        {
          key: "levelName0",
          align: "center",
          renderHeader: (h) => {
            return h("span", "普通会员");
          },
          render: (h, { row }) => {
            if (
              row.list != null &&
              row.list[0].activityPrice === row.list[0].price
            ) {
              return h("span", `${row.list[0].activityPrice + '/年' || "-"}`);
            } else if (
              row.list != null &&
              row.list[0].activityPrice == null
            ) {
              return h("span", `${row.list[0].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.list != null ? row.list[0].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.list != null
                  ? row.list[0].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName1",
          align: "center",
          renderHeader: (h) => {
            return h("span", "金牌会员");
          },
          render: (h, { row }) => {
            if (
              row.list != null &&
              row.list[1].activityPrice === row.list[1].price
            ) {
              return h("span", `${row.list[1].activityPrice + '/年' || "-"}`);
            } else if (
              row.list != null &&
              row.list[1].activityPrice == null
            ) {
              return h("span", `${row.list[1].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.list != null ? row.list[1].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.list != null
                  ? row.list[1].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName2",
          align: "center",
          renderHeader: (h) => {
            return h("span", "钻石会员");
          },
          render: (h, { row }) => {
            if (
              row.list != null &&
              row.list[2].activityPrice === row.list[2].price
            ) {
              return h("span", `${row.list[2].activityPrice + '/年' || "-"}`);
            } else if (
              row.list != null &&
              row.list[2].activityPrice == null
            ) {
              return h("span", `${row.list[2].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.list != null ? row.list[2].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.list != null
                  ? row.list[2].activityPrice  + '/年'|| ""
                  : ""
              ),
            ]);
          },
        },
        {
          key: "levelName3",
          align: "center",
          renderHeader: (h) => {
            return h("span", "皇冠会员");
          },
          render: (h, { row }) => {
            if (
              row.list != null &&
              row.list[3].activityPrice === row.list[3].price
            ) {
              return h("span", `${row.list[3].activityPrice + '/年' || "-"}`);
            } else if (
              row.list != null &&
              row.list[3].activityPrice == null
            ) {
              return h("span", `${row.list[3].price + '/年'}`);
            }
            return h("div", [
              h(
                "span",
                {
                  style: {
                    textDecoration: "line-through",
                    color: "#666",
                  },
                },
                row.list != null ? row.list[3].price + '/年' : ""
              ),
              h(
                "span",
                {
                  style: {
                    marginLeft: "10px",
                    color: "#999",
                  },
                },
                row.list != null
                  ? row.list[3].activityPrice + '/年' || ""
                  : ""
              ),
            ]);
          },
        },
      ],
      list: [],
      type: 0,
    };
  },
  created() {
    this.type = this.$route.query.type || 0;
    this.req_getPriceList();
  },
  methods: {
    req_getPriceList() {
      getPriceList(this.type).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.list = data;
        }
      });
    },
    evt_select(type) {
      this.type = type;
      this.req_getPriceList();
    },
  },
};
</script>
<style lang="less" scoped>
.section {
  background-color: #f0f3f6;
  padding: 58px 0 64px;
  .content {
    width: 1200px;
    margin: 0 auto;
    .nav-warrp {
      display: flex;
      justify-content: space-between;
      .nav-item.active{
        background-color: #F85A36;
        .info{
          .f-text,.d-text {
            color: #fff;
          }
        }

      }
      .nav-item {
        flex: 0 0 380px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100px;
        cursor: pointer;
        border: 1px solid #F85A36;
        border-radius: 10px;
        .info {
          .f-text {
            font-size: 20px;
            color: #F85A36;
            font-weight: bold;
            text-align: center;
          }
          .d-text {
            text-align: center;
            font-size: 14px;
            font-weight: 400;
            color: #F85A36;
          }
        }
      }
    }
  }
}
</style>
